// extracted by mini-css-extract-plugin
export default {"followList":"FollowList_followList__yyNv1","followCount":"FollowList_followCount__V9y97","netWorth":"FollowList_netWorth__-HoaF","alignEnd":"FollowList_alignEnd__PqG7y"};